import axios from "axios";
import GlobalEvent from "@/common/Event";
import BaseCommModel from "./model/base";
import Session from "@/common/Session";
import router from "@/routes";
import _ from "lodash";

// baseURL 규칙: `현재 프로토콜//api.현재 호스트`
const { hostname } = window.location;
let baseURL = "";

if (process.env.NODE_ENV === "development") {
  baseURL = `//api.dev.flybit.com`;
  // baseURL = `https://api.flybit.com/v1`;
} else {
  const isDevelop =
    hostname.includes("local") ||
    hostname.includes("dev") ||
    hostname.includes("localhost");
  if (isDevelop) {
    baseURL = `https://api.dev.flybit.com`;
  } else if (hostname.includes("v1")) {
    baseURL = `https://api.v1.flybit.com`;
  } else {
    baseURL = `https://api.flybit.com`;
  }
}
baseURL = baseURL.replace("m.", "");

// axios 인스턴스 초기화
const ajax = axios.create({
  baseURL,
  crossDomain: true,
  withCredentials: true,
  headers: { "Content-Type": "multipart/form-data" },
});

function Comm() {
  return function(url) {
    return new (function(url) {
      const methods = ["get", "post", "put", "delete"];

      _.forEach(methods, (method) => {
        this[method] = (params = {}) => {
          let data;

          if (!params.noLoading) {
            GlobalEvent.$emit("loading", true);
          } else {
            params = _.omit(params, "noLoading");
          }

          switch (method) {
            case "put":
            case "post":
              data = new FormData();
              _.forEach(params, (val, key) => {
                data.append(key, val);
              });
              break;
            case "get":
            case "delete":
            default:
              const timestamp = Date.now();
              data = { params: { ...params, timestamp } };
              break;
          }

          return ajax[method]
            .apply(ajax, [url, data])
            .then(defaultAjaxCallback)
            .catch(
              params.critic ? criticAjaxErrorHandler : defaultAjaxErrorHandler
            )
            .finally(() => {
              GlobalEvent.$emit("loading", false);
            });
        };
      });

      return this;
    })(url);
  };
}

function defaultAjaxCallback(response) {
  return new BaseCommModel(response);
}

// 치명적 오류 발생
function criticAjaxErrorHandler(err) {
  // 에러 메세지, 코드 override
  err.msg = _.get(
    err,
    ["response", "data", "header", "message"],
    "알 수 없는 오류입니다."
  );
  err.code = _.get(err, ["response", "data", "header", "code"], "-999");
  err.status = _.get(err, ["response", "status"], "-999");

  GlobalEvent.$emit("criticalErrorOccured");

  throw err;
}

function defaultAjaxErrorHandler(err) {
  // 정규 에러가 아닌 서버에러(서버가 죽었거나, 완전히 잘못된 값이 돌아온 경우)
  // if(!_.has(err, ['response', 'status'])) { alert('통신에 실패했습니다.'); return false; }
  const errorData = _.get(err, ["response", "data"], {});
  const errorCode = _.get(errorData, ["header", "code"], 9999);
  switch (_.get(err, ["response", "status"], 999)) {
    // 세션 오류
    case 400:
      // code 4100: 블랙리스트 등록 사용자
      if (errorCode === "4100") {
        Session.forceLogout();
        router.push("/");
      }
      // wlf Y일 때
      if (errorCode === "6100") {
        return GlobalEvent.$emit("wlfReject");
      }
      break;
    // 로그인 되지 않음
    case 401:
      GlobalEvent.$emit("loginException");
      break;

    case 502:
    // 웹서버는 살아있으나 스프링에 해당 모듈이 없음
  }
  // 에러 메세지, 코드 override
  err.msg = _.get(
    err,
    ["response", "data", "header", "message"],
    "알 수 없는 오류입니다."
  );
  err.code = _.get(err, ["response", "data", "header", "code"], "-999");
  err.status = _.get(err, ["response", "status"], "-999");

  throw err;
}

const comm = new Comm();
comm.request = () => new Promise((res) => true);
comm.url = baseURL;

export default comm;
